require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-animate/index.js
// module id = 228
// module chunks = 6